// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k0-0";
export var discountCodeInput = "_k0-1";